if (!customElements.get('agrolix-featured-products')) {
 class AgrolixFeaturedProducts extends HTMLElement {
  static queue = Promise.resolve();
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const signal = this.abort.signal;
   this.addEventListener('change', e => { if (e.target.matches('[data-variant]')) this.updateVariant(e.target); }, { signal });
   this.addEventListener('submit', e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.busy || form.querySelector('button[type=submit]').disabled) return;
    const payload = { id: form.elements.id.value, quantity: Number(form.elements.quantity.value) || 1 };
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    form.querySelector('button').disabled = true;
    if (form.querySelector('select')) form.querySelector('select').disabled = true;
    form.querySelector('[data-button-label]').textContent = this.dataset.workingLabel;
    form.querySelector('[data-status]').textContent = '';
    form.querySelector('[data-recovery]').hidden = true;
    const job = () => this.add(form, payload);
    AgrolixFeaturedProducts.queue = AgrolixFeaturedProducts.queue.then(job, job);
   }, { signal });
   this.dialog = this.querySelector('[data-fallback-drawer]');
   this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
   this.dialog?.addEventListener('click', e => {
    if (e.target !== this.dialog) return;
    const r = this.dialog.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
   }, { signal });
   this.dialog?.addEventListener('close', () => {
    if (this.savedOverflow !== undefined) { document.documentElement.style.overflow = this.savedOverflow; this.savedOverflow = undefined; }
    this.returnFocus?.focus({ preventScroll: true });
   }, { signal });
  }
  updateVariant(select) {
   const o = select.selectedOptions[0], card = select.closest('[data-card]'), form = select.form;
   const price = Number(o.dataset.price), compare = Number(o.dataset.compare), sale = compare > price;
   card.querySelector('[data-price-value]').textContent = o.dataset.priceMoney;
   card.querySelector('[data-compare-value]').textContent = o.dataset.compareMoney;
   card.querySelector('[data-compare]').hidden = !sale;
   card.querySelector('[data-saving]').hidden = !sale;
   card.querySelector('[data-percent]').textContent = sale ? (Math.round((compare - price) / compare * 100) || '<1') : '';
   form.elements.quantity.value = o.dataset.quantity;
   const note = form.querySelector('[data-quantity-note]');
   note.hidden = Number(o.dataset.quantity) <= 1;
   note.querySelector('span').textContent = o.dataset.quantity;
   const available = o.dataset.available === 'true';
   form.querySelector('button').disabled = !available;
   form.querySelector('[data-button-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
   form.querySelector('[data-status]').textContent = '';
   form.querySelector('[data-recovery]').hidden = true;
   if (o.dataset.url) card.querySelectorAll('[data-product-link]').forEach(a => { a.href = o.dataset.url; });
  }
  async add(form, item) {
   let added = false;
   try {
    const native = document.querySelector('theme-drawer#cart-drawer');
    const ids = [...new Set([...(native ? ['cart-drawer-section'] : []), ...[...document.querySelectorAll('cart-items-component[data-section-id]')].map(x => x.dataset.sectionId)])].slice(0, 5);
    const body = { items: [item], sections_url: location.pathname };
    if (ids.length) body.sections = ids;
    const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const result = await response.json();
    if (!response.ok || result.status) { const error = new Error(typeof result.description === 'string' ? result.description : this.dataset.failedLabel); error.shopify = true; throw error; }
    added = true;
    const cartResponse = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error(this.dataset.refreshLabel);
    const cart = await cartResponse.json();
    if (!Array.isArray(cart.items)) throw new Error(this.dataset.refreshLabel);
    let opened = false;
    if (native && result.sections?.['cart-drawer-section']) {
     try {
      const { morphSection } = await import(this.dataset.morphUrl);
      await morphSection('cart-drawer-section', result.sections['cart-drawer-section'], { mode: 'hydration', injectStylesheet: true });
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (typeof drawer?.open === 'function' && this.isConnected) {
       await this.notifyCart(cart, result.sections, drawer.querySelector('cart-items-component') || this, 'add', item);
       drawer.open();
       opened = true;
      }
     } catch (_) { /* The standalone drawer remains available if theme hydration fails. */ }
    }
    if (!opened) {
     await this.notifyCart(cart, result.sections, this, 'update', item);
     if (this.isConnected) {
      if (typeof native?.close === 'function') native.close();
      this.renderFallback(cart, form.querySelector('button'));
     }
    }
    form.querySelector('[data-status]').textContent = this.dataset.addedLabel;
   } catch (error) {
    form.querySelector('[data-status]').textContent = added ? this.dataset.refreshLabel : (error.shopify ? error.message : this.dataset.failedLabel);
    form.querySelector('[data-recovery]').hidden = false;
   } finally {
    delete form.dataset.busy;
    form.removeAttribute('aria-busy');
    const select = form.querySelector('select');
    if (select) select.disabled = false;
    const available = !select || select.selectedOptions[0].dataset.available === 'true';
    form.querySelector('button').disabled = !available;
    form.querySelector('[data-button-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
   }
  }
  async notifyCart(cart, sections, target, action, item) {
   const detail = { items: cart.items, itemCount: cart.item_count, sections, source: 'agrolix-featured-products', didError: false };
   let event;
   try {
    const { CartLinesUpdateEvent } = await import('@shopify/events');
    event = new CartLinesUpdateEvent({ action, context: 'product', lines: [{ merchandiseId: String(item.id), quantity: item.quantity }], promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail }) });
   } catch (_) {
    event = new Event('shopify:cart:lines-update', { bubbles: true });
    Object.assign(event, { action, context: 'product', lines: [{ merchandiseId: String(item.id), quantity: item.quantity }], promise: Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail }) });
   }
   target.dispatchEvent(event);
  }
  money(cents, currency) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || this.dataset.currency || 'INR' }).format(cents / 100); }
  renderFallback(cart, trigger) {
   const list = this.querySelector('[data-cart-items]');
   list.replaceChildren();
   for (const item of cart.items) {
    const row = document.createElement('div'); row.className = 'afp__drawer-item';
    const img = document.createElement('img'); img.alt = ''; img.width = 76; img.height = 76;
    if (item.image) { img.src = item.image; img.loading = 'lazy'; row.append(img); }
    const text = document.createElement('div');
    const link = document.createElement('a'); link.href = item.url || this.dataset.cartUrl; link.textContent = item.product_title || item.title; text.append(link);
    if (item.variant_title && item.variant_title !== 'Default Title') { const variant = document.createElement('p'); variant.textContent = item.variant_title; text.append(variant); }
    const price = document.createElement('p'); price.textContent = `${item.quantity} × ${this.money(item.final_price, cart.currency)}`; text.append(price);
    const total = document.createElement('strong'); total.textContent = this.money(item.final_line_price, cart.currency); text.append(total);
    row.append(text); list.append(row);
   }
   this.querySelector('[data-subtotal]').textContent = this.money(cart.total_price, cart.currency);
   this.returnFocus = trigger;
   if (!this.dialog.open) {
    this.savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    this.dialog.showModal();
    this.querySelector('[data-close]').focus();
   }
  }
  disconnectedCallback() {
   if (this.dialog?.open) this.dialog.close();
   if (this.savedOverflow !== undefined) document.documentElement.style.overflow = this.savedOverflow;
   this.savedOverflow = undefined;
   this.abort?.abort(); this.abort = null;
  }
 }
 customElements.define('agrolix-featured-products', AgrolixFeaturedProducts);
}
